export const SITE_URL = process.env.REACT_APP_SITE_URL?.replace(/\/$/, '');
if (!SITE_URL) throw new Error('REACT_APP_SITE_URL is required');

export function cleanSeoText(value) {
  let text = String(value ?? '');
  const decoder = document.createElement('textarea');
  for (let i = 0; i < 3 && /&(?:#\w+|\w+);/.test(text); i++) {
    decoder.innerHTML = text;
    text = decoder.value;
  }
  return text.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
}

export const absoluteUrl = path => new URL(path, `${SITE_URL}/`).href;

export function breadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org', '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem', position: i + 1, name: item.name, item: absoluteUrl(item.path),
    })),
  };
}